<template>
  <div class="reassurance-step-container">
    <div class="reassurance-step__title">
      {{ trans('guided_search.reassurance.title') }}
    </div>
    <div class="reassurance-step__description">
      <span>{{ trans('guided_search.reassurance.description.1') }}</span>
      <span>{{ trans('guided_search.reassurance.description.2') }}</span>
    </div>
    <MatchPictures class="mb-6" />
    <SocialRating />
    <button
      class="btn btn--primary btn--jumbo"
      @click="nextStep"
    >
      <span>
        {{ trans('guided_search.reassurance.start') }}
      </span>
    </button>
    <div class="reassurance-step__conditions">
      <!-- eslint-disable vue/no-v-html -->
      <p v-html="trans('guided_search.form.conditions.1', { link_cgu: $linkCgu, link_poc: $linkPoc, })" />
      <p v-html="trans('guided_search.form.conditions.2', { link_recaptcha: $linkRecaptcha, })" />
      <!-- eslint-enable vue/no-v-html -->
    </div>
  </div>
</template>

<script>
import MatchPictures from '@components/MatchPictures.vue';
import SocialRating from '@molecules/components/SocialRating.vue';
import { translationMixin } from '@elements/translation';

export default {
  components: { MatchPictures, SocialRating },
  mixins: [ translationMixin ],
  mounted() {
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'reassurance',
      funnel: 'support-contact-form',
      step: 'reassurance',
    });
  },
  methods: {
    nextStep() {
      this.$emit('next-step');
    },
  },
};
</script>
